import { useMemoShareListQuery } from '../query/memoShareQuery';
import { useAsyncOperations } from './asyncCommon';

// 定义MemoShareManager接口
export interface MemoShareManager {
  // Store状态
  memoShares: any[];
  currentMemoShare: any | null;
  status: 'idle' | 'loading' | 'error';
  isSyncing: boolean;
  
  // Loading states
  isLoading: boolean;
  memoSharesLoading: boolean;
  
  // Error states
  error: string | null;
  memoSharesError: any;
  
  // Integration actions
  syncAllData: () => Promise<boolean>;
  
  // Combined state
  hasMemoShares: boolean;
  isMemoShareLoading: boolean;
  
  // 智能状态判断
  canCreateMemoShare: boolean;
  canEditMemoShare: boolean;
  canDeleteMemoShare: boolean;
}

// 综合管理hook，结合React Query和Zustand
export const useMemoShareManager = (): MemoShareManager => {
  const { safeAsyncOperation, queryClient } = useAsyncOperations();
  
  const { 
    data: memoSharesData, 
    isLoading: memoSharesLoading, 
    error: memoSharesError 
  } = useMemoShareListQuery();

  // 智能错误处理
  const hasError = memoSharesError;
  
  const syncAllMemoShareData = async () => {
    const result = await safeAsyncOperation(async () => {
      await queryClient.refetchQueries({ queryKey: ['memoShares'] });
      return { success: true };
    }, '同步所有Memo Share数据失败');
    
    return result.success;
  };
  
  // 基于React Query数据的状态计算
  const memoShares = memoSharesData || [];
  const hasMemoShares = memoShares.length > 0;
  const isMemoShareLoading = memoSharesLoading;
  
  return {
    // Store状态（基于React Query）
    memoShares,
    currentMemoShare: null, // 需要时可以从其他地方获取
    status: memoSharesLoading ? 'loading' : hasError ? 'error' : 'idle',
    isSyncing: false,
    
    // Loading states
    isLoading: memoSharesLoading,
    memoSharesLoading,
    
    // Error states
    error: hasError ? '数据加载失败' : null,
    memoSharesError,
    
    // Integration actions
    syncAllData: syncAllMemoShareData,
    
    // Combined state
    hasMemoShares,
    isMemoShareLoading,
    
    // 智能状态判断
    canCreateMemoShare: !memoSharesLoading && !hasError,
    canEditMemoShare: false, // 需要时可以从其他地方获取currentMemoShare
    canDeleteMemoShare: false, // 需要时可以从其他地方获取currentMemoShare
  };
};